import { portaalQueryOptions } from '@connected/portaal-sdk/queries/options';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CustomerReportContent } from '@/components/customer-reports-content';

export const Route = createFileRoute(
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/$notificationId/',
)({
    component: RouteComponent,
});

export function RouteComponent() {
    const params = Route.useParams();

    const { data: installationData } = useQuery(portaalQueryOptions.electrical.finalcircuits.view({
        ElectricalProjectFinalCircuitId: params.circuitId,
    }));

    if (!installationData?.FinalCircuit) {
        return null;
    }

    return (
        <CustomerReportContent
            query={{ ElectricalProjectObservationId: params.notificationId }}
            installation={installationData?.FinalCircuit}
        />
    );
}
